import { InputAdornment, TextField as MuiTextField } from '@mui/material';
import React, { FC, forwardRef, useMemo, useState } from 'react';

import { TogglePasswordLegibility } from './TextField.parts';
import { TextFieldProps } from './TextField.types';

function getFieldType(type: TextFieldProps['type'], legible = true) {
  if (type === 'password' && legible) {
    return 'text';
  }
  return type;
}

export const TextField: FC<TextFieldProps> = forwardRef<
  HTMLDivElement,
  TextFieldProps
>(({ type, ...props }, ref) => {
  const [legible, setLegible] = useState(type !== 'password');
  const computedType = useMemo(
    () => getFieldType(type, legible),
    [type, legible]
  );

  return (
    <MuiTextField
      {...props}
      ref={ref}
      type={computedType}
      InputProps={{
        ...props.InputProps,
        ...(type === 'password'
          ? {
              endAdornment: (
                <InputAdornment position="end">
                  <TogglePasswordLegibility
                    legible={legible}
                    onClick={() => setLegible(!legible)}
                  />
                </InputAdornment>
              )
            }
          : {})
      }}
    />
  );
});
